import { WidthContainer } from '@pata-app/ui-document';
import { Button } from '@pata-app/ui-form';
import { Image } from '@pata-app/ui-media';

import React from 'react';
import { useNavigate } from 'react-router-dom';

import { getEnv } from '../../../../lib/utils/getEnv';
import { ActionContainer, BusinessBenefitsContainer, BusinessBenefitsContent } from './pataPay.styled';

const { VITE_CDN_BASE_URL } = getEnv();

export const PataPay = () => {
  const navigate = useNavigate();

  const handlePataPayLink = () => {
    navigate('/business/pata-pay');
  };

  return (
    <BusinessBenefitsContainer>
      <WidthContainer noBackground>
        <Image
          src={`${VITE_CDN_BASE_URL}/images/image-terminal-with-pata.webp`}
          alt="Pet groomer using the PataPay card reader to pay payments in person"
          height={1500}
          width={2500}
        />
        <BusinessBenefitsContent>
          <h2>
            Flexible payment methods for pet groomers with <span>PataPay</span>
          </h2>
          <p>
            Whether you’re a solo pet groomer or run a busy salon, start taking payments online or in person with
            deposits, card readers, and payment links.
          </p>

          <ul>
            <li>Take upfront payments to reduce cancellations and no-shows</li>
            <li>Securely store clients’ payment cards for any future late cancellation or no-show fees</li>
            <li>Accept in-person payments via Pata card reader with Apple/Google Pay support</li>
            <li>Stay in control by tracking every transaction on our pet salon platform</li>
            <li>All this with low processing fees per payment and no monthly charges</li>
          </ul>

          <ActionContainer>
            <Button onClick={handlePataPayLink}>Find out more</Button>
          </ActionContainer>
        </BusinessBenefitsContent>
      </WidthContainer>
    </BusinessBenefitsContainer>
  );
};
